import React from 'react';

import { CompanyLogo } from '../companyLogo/companyLogo.component';
import { LogoVersion } from '../companyLogo/companyLogo.enums';
import { SocialMediaType } from '../../enums/socialMediaType.enum';
import { PageType } from '../../enums/pageType.enum';
import { SocialMediaItem } from '../../interfaces/socialMedia.types';
import { MenuPosition } from '../../interfaces/menu.types';
import { renderWhenTrueOr, renderInternalLink, renderExternalLink, renderWhenTrue } from '../../utils';
import { FooterBarLogo } from '../../interfaces/footerBarLogo.types';
import { LanguageSlug } from '../../enums/languageSlug.enum';

import {
  Container,
  MenuColumn,
  MenuPositionItem,
  SocialIconContainer,
  SocialIcon,
  EULogo,
  EULogosContainer,
  TopContainer,
  MenuContainer,
  SocialContainer,
  BottomContainer,
  CopyrightText,
  CompanyLogoContainer,
  SocialIconsContainer,
  CopyrightLink,
  ExternalLink,
  EULogosInnerContainer,
  BottomInnerContainer,
  MenuColumnsContainer,
} from './footer.styled';
import { FooterData } from './footer.types';
import FbIcon from './images/fb.svg';
import YoutubeIcon from './images/youtube.svg';
import LinkedInIcon from './images/linkedin.svg';
import XIcon from './images/x.svg';
import InstagramIcon from './images/instagram.svg';
import TikTokIcon from './images/tiktok.svg';

export const Footer: React.FC<FooterData> = (data: FooterData) => {
  const { 
    menu, 
    logoData, 
    socialMediaData, 
    authorLabel, 
    logoGroupData, 
    currentLanguage, 
    hasEuLogos = true, 
  } = data;
  const linkForLanguageButton = `/${currentLanguage === LanguageSlug.Pl ? '' : currentLanguage}`;

  const renderMenuPositions = (columnNumber: number) => menu
    .filter((menuPosition: MenuPosition) => parseInt(menuPosition.columnNumber) === columnNumber)
    .map((menuPosition: MenuPosition) => {
      const renderLink = renderWhenTrueOr(
        () => renderInternalLink(menuPosition.label, menuPosition.internalPage, currentLanguage),
        () => renderExternalLink(menuPosition.label, menuPosition.externalPage)
      );

      return (
        <MenuPositionItem key={menuPosition.label}>
          {renderLink(menuPosition.positionType === PageType.Internal)}
        </MenuPositionItem>
      );
    });

  const getSocialMediaIcon = (socialMediaType: SocialMediaType) => {
    switch (socialMediaType) {
      case SocialMediaType.Facebook:
        return FbIcon;
      case SocialMediaType.Youtube:
        return YoutubeIcon;
      case SocialMediaType.LinkedIn:
        return LinkedInIcon;
      case SocialMediaType.X:
        return XIcon;
      case SocialMediaType.Instagram:
        return InstagramIcon;
      case SocialMediaType.TikTok:
        return TikTokIcon;
    }
  };

  const renderSocialIcons = () => socialMediaData.map((socialMediaItem: SocialMediaItem) => (
    <SocialIconContainer key={socialMediaItem.url} href={socialMediaItem.url} target='_blank'>
      <SocialIcon src={getSocialMediaIcon(socialMediaItem.type)} alt={socialMediaItem.type} />
    </SocialIconContainer>
  ));

  const renderEULogos = () => logoGroupData.map((logo: FooterBarLogo) => (
    <ExternalLink href={logo.target} key={logo.target} target='_blank'>
      <EULogo src={logo.image?.localFile?.url} alt={logo.image.alt_text} />
    </ExternalLink>
  ));

  const renderEuLogosContainer = renderWhenTrue(() => (
    <EULogosContainer>
      <EULogosInnerContainer>{renderEULogos()}</EULogosInnerContainer>
    </EULogosContainer>
  ));

  return (
    <Container>
      {renderEuLogosContainer(hasEuLogos)}
      <TopContainer>
        <MenuContainer>
          <MenuColumnsContainer>
            <MenuColumn>
              {renderMenuPositions(1)}
            </MenuColumn>
          </MenuColumnsContainer>
          <MenuColumnsContainer>
            <MenuColumn>
              {renderMenuPositions(2)}
            </MenuColumn>
            <MenuColumn>
              {renderMenuPositions(3)}
            </MenuColumn>
          </MenuColumnsContainer>
        </MenuContainer>
        <SocialContainer>
          <CompanyLogoContainer>
            <CompanyLogo
              target={linkForLanguageButton}
              logoData={logoData}
              version={LogoVersion.Light}
            />
          </CompanyLogoContainer>
          <SocialIconsContainer>
            {renderSocialIcons()}
          </SocialIconsContainer>
        </SocialContainer>
      </TopContainer>
      <BottomContainer>
        <BottomInnerContainer>
          <CopyrightText>
            {authorLabel}
            {' '}
            <CopyrightLink href='https://mug.pl' target='_blank'>
              MUG
            </CopyrightLink>
          </CopyrightText>
          <CopyrightText>Copyright © {new Date().getFullYear()} by Asket</CopyrightText>
        </BottomInnerContainer>
      </BottomContainer>
    </Container>
  );
}
